import Vue from 'vue';
import moment from 'moment-timezone'

Vue.filter('defaultDate', (value, format, breakLine = false) => {
    if (value) {
        moment.locale('pt-br');

        if (format === 'fromNow') {
            return moment.tz(value, 'America/Sao_Paulo').fromNow();
        } else {
            if (!format) {
                format = 'DD/MM/YYYY';
            }

            if (breakLine) {
                format = format.replace(' ', '[<br />]');
            }

            return moment.tz(value, 'America/Sao_Paulo').format(format);
        }
    }

    return value;
});